module.exports = __webpack_public_path__ + "static/media/Bupa Nacional Vital.523e236a.webp";